import { Map, Record } from 'immutable';
import { handleActions } from 'redux-actions';
import * as t from './actionTypes';

const ReducerRecord = new Record({
  entities: Map(),
  app: Map({
    active: null,
    lastUpdate: null,
    search: ''
  }),
  ui: Map({
    isLoading: false,
    isError: false,
    errorMessage: null
  })
});
const initialState = new ReducerRecord();

export default handleActions(
  {
    [t.ENTITIES_ADD]: (state, action) =>
      state
        .set('entities', state.get('entities').merge(action.payload))
        .setIn(['app', 'lastUpdate'], action.meta.updatedAt),

    [t.NETWORK_START]: state =>
      state.set(
        'ui',
        state.get('ui').merge(
          Map({
            isLoading: true,
            isError: false,
            errorMessage: null
          })
        )
      ),

    [t.NETWORK_RESET]: state =>
      state.set(
        'ui',
        state.get('ui').merge(
          Map({
            isLoading: false,
            isError: false,
            errorMessage: null
          })
        )
      ),

    [t.NETWORK_ERROR]: (state, action) =>
      state.set(
        'ui',
        state.get('ui').merge(
          Map({
            isLoading: false,
            isError: true,
            errorMessage: action.payload
          })
        )
      ),

    [t.ACTIVE_SET]: (state, action) =>
      state.setIn(['app', 'active'], action.payload),

    [t.SEARCH_SET]: (state, action) =>
      state.setIn(['app', 'search'], action.payload)
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/modules/clients/reducer.js